import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import SettingsBillingPage, { defaultUrl as billingUrl } from './SettingsBillingPage';
import SettingsGhaPage, { defaultUrl as ghaUrl } from './SettingsGhaPage';
import SettingsNotificationsPage, { defaultUrl as notificationsUrl } from './SettingsNotificationsPage';
import SettingsOrganizationsPage, { defaultUrl as organizationsUrl } from './SettingsOrganizationsPage';
import SettingsProfilePage, { defaultUrl as profileUrl } from './SettingsProfilePage';
export const defaultUrl = '/settings';
class SettingsPage extends Component {
    render() {
        const { match } = this.props;
        return (_jsxs(Switch, { children: [_jsx(Route, { path: match.url + billingUrl, component: SettingsBillingPage }), _jsx(Route, { path: match.url + ghaUrl, component: SettingsGhaPage }), _jsx(Route, { path: match.url + notificationsUrl, component: SettingsNotificationsPage }), _jsx(Route, { path: match.url + organizationsUrl, component: SettingsOrganizationsPage }), _jsx(Route, { path: match.url + profileUrl, component: SettingsProfilePage }), _jsx(Route, { path: match.url + profileUrl, component: SettingsProfilePage }), _jsx(Route, { render: ( /*props*/) => _jsx(Redirect, { to: match.url + profileUrl }) })] }));
    }
}
export default SettingsPage;
